module.exports = __webpack_public_path__ + "static/media/driver-id-card.820d88ac.png";